namespace GeniuzPOS.PosShift {
    export class PsTaxInvoiceHdColumns {
        static columnsKey = 'PosShift.PsTaxInvoiceHd';
    }
}
